<template>
  <span
    class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-[12px] font-semibold"
    :class="styles"
    >{{ label }}</span
  >
</template>

<script>
const META = {
  violator: { label: "Violator", classes: "bg-red-100 text-red-800" },
  non_participant: {
    label: "Non-Participant",
    classes: "bg-yellow-100 text-yellow-800",
  },
  fraud_alert: { label: "Fraud Alert", classes: "bg-orange-100 text-orange-800" },
};

export default {
  name: "CategoryBadge",
  props: {
    category: { type: String, default: "" },
  },
  computed: {
    label() {
      return (META[this.category] || {}).label || this.category;
    },
    styles() {
      return (META[this.category] || {}).classes || "bg-gray-100 text-gray-800";
    },
  },
};
</script>
